module.exports = __webpack_public_path__ + "8bec44e2644629c2634420859e8af111.svg";